const allowedCompanyIds = new Set([
  "6a997e4869758376481282c1",
  "686becf5e5695daae65de088",
  "69241b79641f346bdf954396",
]);

export const canAccessNewAnalytics = (companyId) => allowedCompanyIds.has(companyId);
